var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7C3 4.79086 4.79086 3 7 3H17C19.2091 3 21 4.79086 21 7V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V7Z",
    stroke: "#209BDD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15L5.8055 12.1945C6.68783 11.3122 8.1538 11.4443 8.86408 12.4703L10.7664 15.218C11.4311 16.1781 12.7735 16.3669 13.6773 15.6275L16.0991 13.646C16.8944 12.9954 18.0533 13.0532 18.7798 13.7798L21 16",
    stroke: "#209BDD",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 2,
    fill: "#209BDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBox);
export default __webpack_public_path__ + "static/media/imageBox.29229c15d6a2670954f915f87d20bbf9.svg";
export { ForwardRef as ReactComponent };